<template>
  <div
    v-if="isAdmin && isPromoteur">
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span>Agence</span>
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          v-if="canAddUsers"
          class="page-header-btn is-small is-secondary is-widthFixToHeaderAccount"
          :to="{name: 'AgenceCreate'}">
          <span class="icon is-medium"><i class="fas fa-plus-circle"></i></span><span>Créer une Agence</span>
        </router-link>
      </template>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="false"
      :has-padd-right-normal="true">
      <div class="is-border ">
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>
        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="true">
          <table class="table is-narrow is-fullwidth is-last-fixed-small has-actionsontd">
            <thead class="has-cells-vcentered">
              <tr class="is-size-9">
                <th>
                  Nom
                </th>
                <th class="is-narrow">
                  Membres
                </th>
                <th class="has-text-centered"></th>
              </tr>
            </thead>
            <tbody class="has-cells-vcentered">
              <tr
                v-for="(channel) in items"
                :key="channel.pk"
                class="is-size-6"
                :id="'e' + channel.pk">
                <td class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'AgenceVue', params: {id: channel.pk}}"
                    class="fullLink">
                    {{ channel.name }}
                  </router-link>
                </td>
                <td class="is-narrow">
                  <span>{{ channel.users.length }} membre<span v-if="channel.users.length > 1">s</span></span>
                </td>
                <td>
                  <display-button-list
                    :buttons="buttonList"
                    :data="channel">
                  </display-button-list>
                </td>
              </tr>
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucune agence disponible
            </h2>
          </div>
        </div>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event)"></pagination>
      </div>
    </page-content>
  </div>
</template>

<script>
import { GenericList, Sort, DefaultValues, Filter } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'ChannelListVue',
  mixins: [GenericList, Sort, DefaultValues, Filter],
  data () {
    return {
      buttonList: [
        {
          action: (id) => {
            this.$router.push({ name: 'AgenceVue', params: { id } })
          },
          icon: 'fa-eye'
        }
      ],
      service: 'AGENCE'
    }
  },
  computed: {
    ...mapGetters(['isManager', 'isAdmin', 'isPromoteur', 'canAddUsers'])
  },
  methods: {
    changeView (link) {
      this.$router.push({ name: link })
    }
  }
}
</script>
